<ion-header>
  <ion-toolbar>
    <ion-title>Boletos</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/transportec" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment mode="md" [(ngModel)]="direction" (ionChange)="changeDirection()">
      <ion-segment-button value="go">
        <ion-label>
          LLEGADA
          <br />
          Voy al Tec
        </ion-label>
      </ion-segment-button>
      <div class="separator"></div>
      <ion-segment-button value="return">
        <ion-label>
          SALIDA
          <br />
          Salgo del Tec
        </ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Selecciona tu destino</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-item (click)="searchStops()">
        <ion-textarea
          [label]="direction==='go' ? '¿De dónde sales?' : '¿A dónde vas?'"
          labelPlacement="stacked"
          readonly
          name="stop"
          type="text"
          placeholder="Selecciona tu destino"
          [value]="stop?.name"
        ></ion-textarea>
      </ion-item>
      <ion-item id="open-modal">
        <ion-label position="stacked">¿Cuándo?</ion-label>
        <ion-datetime-button datetime="datetime"></ion-datetime-button>
        <ion-modal [keepContentsMounted]="true" trigger="open-modal">
          <ng-template>
            <ion-datetime
              id="datetime"
              [showDefaultButtons]="true"
              [(ngModel)]="date"
              [min]="today"
              [max]="maxDate"
              presentation="date"
              [preferWheel]="true"
              locale="es-MX"
              doneText="Seleccionar"
              cancelText="Cancelar"
            ></ion-datetime>
          </ng-template>
        </ion-modal>
      </ion-item>
      <ion-button shape="round" color="primary" expand="block" (click)="goSearch()" [disabled]="!date || !stop">
        Buscar
      </ion-button>
    </ion-card-content>
  </ion-card>
</ion-content>
